import { FieldType } from '../../types';

export const doesUserProfileFieldMatchSearch = (
  name: string,
  fieldType: FieldType,
  search: string,
) => !search.length || name.concat(fieldType).toLowerCase().includes(search.toLowerCase());
